/* global axios */
import ApiClient from '../ApiClient';

class ConversationAiUsageAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true, saas: true });
  }

  getUsage(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_usage`);
  }
}

export default new ConversationAiUsageAPI();
